<template>
    <div id="part_backorder_reporting">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title">Backorder Report</div>
                    <!-- Button for Clear Cache -->
                    <clear-cache-data :pageKey="[pageKey]"></clear-cache-data>
                </div>
                <div class="container-fluid">
                    <div class="from-group">
                        <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                            <strong id="errorMsg" class="field-error"></strong>
                        </div>
                    </div>
                    <div class="admin-page-content part-backorder-list">
                        <data-table-filter-config :moduleName="'partBackorderReport'" :removeLineButtonVisibility="true"
                            :addFilterButtonVisibility="true" @cancelSelection="cancelAll"
                            :allowSameFilter="'allow'"></data-table-filter-config>
                        <section class="data-table bg-white">
                            <custom-pagination :page-changed="onPageChange" :per-page-changed="onPerPageChange"
                                :moduleName="'partBackorderReport'" :position="'top'">
                            </custom-pagination>
                            <vue-good-table ref="listPartBackorderReport" mode="remote" title="Part Backorder Report"
                                @on-page-change="onPageChange" @on-column-filter="onColumnFilter"
                                @on-per-page-change="onPerPageChange" @on-sort-change="onSortChange"
                                :totalRows="totalRecords" :columns="userColumns" :rows="rows" :pagination-options="{
                                    enabled: false,
                                    position: 'both',
                                    perPage: perPage,
                                    perPageDropdown: dropDownPerPage,
                                    dropdownAllowAll: false,
                                }" :select-options="{
                                    enabled: false,
                                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                    selectionInfoClass: 'custom-class',
                                    selectionText: 'rows selected',
                                    clearSelectionText: 'clear',
                                }" :search-options="{
                                    enabled: false,
                                }">

                                <template slot="table-row" slot-scope="props" v-for="(row, key) in rows">
                                    <div :key="key">
                                        <div v-if="props.column.field == 'action'">
                                            <a style="cursor: pointer;color: var(--secondary-font-color);"
                                                v-if="canEditReport" @click="showEditModal(props.row)"
                                                title="Edit Backorder Report"><i class="fp-edit"></i></a>
                                        </div>
                                        <div v-else-if="props.column.field === 'backorder_comment'">
                                            <span>
                                                {{ props.row.backorder_comment ? props.row.backorder_comment.slice(0,
                                                    10) : '' }}<span
                                                    v-if="props.row.backorder_comment && props.row.backorder_comment.length > 10">...</span>
                                            </span>
                                            <span
                                                v-if="props.row.backorder_comment && props.row.backorder_comment.length > 10">
                                                <a href="#" class="color-blue"
                                                    @click.prevent="showCommentModal(props.row.backorder_comment)">Read
                                                    More</a>
                                            </span>
                                        </div>
                                        <div v-else>
                                            {{ props.formattedRow[props.column.field] }}
                                        </div>
                                    </div>
                                </template>
                            </vue-good-table>
                            <custom-pagination :page-changed="onPageChange" :per-page-changed="onPerPageChange">
                            </custom-pagination>
                        </section>
                    </div>
                </div>

                <!-- modal to show full comment -->
                <div v-if="modal_comment" class="modal fade" id="backorderCommentModal" tabindex="-1" role="dialog">
                    <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content p-3">
                            <div class="modal-header">
                                <h5 class="modal-title" id="commentModalLabel">Backorder Comment</h5>
                                <a type="button" class="close ml-auto" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </a>
                            </div>
                            <div class="modal-body p-0">
                                <textarea rows="6" readonly class="form-control">{{ modal_comment }}</textarea>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal fade" id="editBackorderReport" tabindex="-1" role="dialog" data-backdrop="static">
                    <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content">
                            <div style="display: flex; justify-content: center; align-items: center;" class="mt-4 mb-3">
                                <img :src="logoPath" alt="Dealer Pro" style="height: 70px; margin-right: 7px">
                            </div>
                            <div class="pl-5 pr-5 mt-1">
                                <div class="form-row">
                                    <div class="col-12 form-group">
                                        <label class="control-label" for="backorder-eta">Backorder ETA:</label>
                                        <input type="text" class="form-control" v-model="backorder_eta"
                                            name="backorder-eta" id="backorder-eta" placeholder="Backorder ETA">
                                        <span class="field-error" v-if="backorder_eta_err_msg">{{ backorder_eta_err_msg
                                            }}</span>
                                    </div>
                                    <div class="col-12 form-group">
                                        <div class="d-flex justify-content-between">
                                            <label class="control-label require" for="backorder-comment">Backorder
                                                Comment:</label>
                                            <span style="font-size: 14px;">{{ backorder_comment_count }}/3000</span>
                                        </div>
                                        <textarea class="form-control" id="backorder-comment"
                                            v-model.trim="backorder_comment" rows="4" maxlength="3000"
                                            placeholder="Backorder Comment"></textarea>
                                        <span class="field-error" v-if="backorder_comment_err_msg">{{
                                            backorder_comment_err_msg
                                            }}</span>
                                    </div>
                                    <div class="col-12 form-group">
                                        <label class="control-label" for="backorder-status">Backorder Status:</label>
                                        <v-select v-model="backorder_status" name="backorder-status"
                                            placeholder="Select Status" @change="backorderStatusChanged($event)"
                                            label="text" :options="['Open', 'Closed']" :searchable="false">
                                        </v-select>
                                        <span class="field-error" v-if="backorder_status_err_msg">{{
                                            backorder_status_err_msg }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="d-flex justify-content-around mt-4 mb-3">
                                <button type="button" @click="validateFields()" class="btn-lg btn-primary"
                                    style="width: 150px;">Save
                                </button>
                                <button type="button" @click="closeModal()" class="btn-lg btn-primary"
                                    style="width: 150px;">Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>

    </div>
</template>
<script>
import Vue from "vue";

import LoadingContent from "@/components/LoadingContent.vue";
Vue.component("loading-content", LoadingContent);
import 'vue-good-table/dist/vue-good-table.css';
import VueGoodTable from 'vue-good-table';
Vue.use(VueGoodTable);

import { commonMixins } from '../mixins/commonMixins';
import { dataTableMixins } from '../mixins/dataTableMixins';
import { contractMixins } from '../mixins/contractMixins';

export default {
    name: "PartBackorderReporting",
    components: {
        customPagination: () => import('@/components/layout/CustomPagination'),
        dataTableFilterConfig: () => import('@/components/DataTableFilterConfig'),
        clearCacheData: () => import('@/components/ClearCacheData'),
        appFooter: () => import('@/components/Footer'),
    },
    mixins: [commonMixins, dataTableMixins, contractMixins],
    metaInfo() {
        return { title: "Part Backorder Report | " + process.env.COPYRIGHT_NAME }
    },
    data: () => ({
        permissions: [],
        cantAccessPage: '',
        userColumns: [],
        columns: [
            {
                label: 'Actions',
                field: 'action',
                sortable: false,
                filterable: false,
                hidden: true,
                width: '100px'
            },
            {
                label: 'Part Number',
                field: 'part_number',
                fpFieldType: "text",
                hidden: false,
                filterable: true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Part Number", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [],
                    trigger: "enter" //only trigger on enter not on keyup
                },
            },
            {
                label: 'B/O QTY',
                field: 'backorder_qty',
                fpFieldType: "integer",
                hidden: false,
                filterable: true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "B/O QTY", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [],
                    trigger: "enter" //only trigger on enter not on keyup
                },
            },
            {
                label: 'Order Number',
                field: 'order_number',
                fpFieldType: "text",
                hidden: false,
                filterable: true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Order Number", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [],
                    trigger: "enter" //only trigger on enter not on keyup
                },
            },
            {
                label: 'Order Date',
                field: 'order_date',
                fpFieldType: "date",
                hidden: false,
                filterable: true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Order Date", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
            },
            {
                label: 'Dealer Code',
                field: 'dealer_code',
                fpFieldType: "text",
                hidden: false,
                filterable: true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Dealer Code", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
            },
            {
                label: 'Dealer PO#',
                field: 'dealer_po',
                fpFieldType: "text",
                hidden: false,
                filterable: true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Dealer PO#", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
            },
            {
                label: 'ETA',
                field: 'backorder_eta',
                fpFieldType: "text",
                hidden: false,
                filterable: false,
                sortable: false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "ETA", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
            },
            {
                label: 'Comments',
                field: 'backorder_comment',
                fpFieldType: "text",
                hidden: false,
                filterable: false,
                sortable: false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Comments", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
            },
            {
                label: 'Status',
                field: 'backorder_status',
                fpFieldType: "option",
                hidden: false,
                filterable: true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Status", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter", //only trigger on enter not on keyup
                    filterDropdownItems: ['Open', 'Closed'],
                },
            }
        ],
        rows: [],
        totalRecords: 0,
        loading: false,
        pageKey: "_part_backorder_report_list_",
        errorMsg: "",
        canEditReport: false,
        editId: 0,
        logoPath: '',
        backorder_eta: '',
        backorder_comment: '',
        backorder_comment_count: 0,
        backorder_status: '',
        backorder_eta_err_msg: '',
        backorder_comment_err_msg: '',
        backorder_status_err_msg: '',
        modal_comment: '',
    }),
    watch: {
        //check permission change
        permissions: function (permissions) {
            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'ev_part_backorder_reporting') {
                        self.cantAccessPage = true;
                    }
                    if (permissions[i].name == 'ev_edit_part_backorder_reporting') {
                        self.canEditReport = true;
                        self.columns.find(column => column.field === 'action').hidden = false;
                    }
                }
            }
        },
        backorder_comment(value) {
            if (value) {
                if (value.length > 3000) {
                    this.backorder_comment = value.substring(0, 3000);
                }
                this.backorder_comment_count = value.length;
            }
        },
    },
    created: function () {
        this.logoPath = process.env.LOGO_PATH;
    },
    mounted: function () {
        var self = this;
        self.getPermissions();
    },
    methods: {
        showCommentModal(comment) {
            this.modal_comment = comment;
            this.$nextTick(() => {
                $('#backorderCommentModal').modal('show');
            });
        },
        backorderStatusChanged(value) {
            if (value == '' || value == null) {
                this.backorder_status = '';
            }
        },
        cancelAll: function () {
            this.$refs.listPartBackorderReport.unselectAllInternal();
        },
        showEditModal(row) {
            var self = this;
            self.editId = row.id;
            self.backorder_eta = row.backorder_eta;
            self.backorder_comment = row.backorder_comment;
            self.backorder_status = row.backorder_status;

            $('#editBackorderReport').modal('show');
        },
        closeModal() {
            this.clearErrFields();

            this.editId = 0;
            this.backorder_eta = '';
            this.backorder_comment = '';
            this.backorder_status = '';
            this.backorder_comment_count = 0;

            $('#editBackorderReport').modal('hide');
        },
        saveBackorderFields() {
            var self = this;
            self.loading = true;

            let formData = new FormData();
            formData.append('backorder_eta', self.backorder_eta);
            formData.append('backorder_comment', self.backorder_comment);
            formData.append('backorder_status', self.backorder_status);
            formData.append('part_order_item_id', self.editId);

            $.ajax({
                url: process.env.ROOT_API + "/update-backorder-report",
                type: "POST",
                data: formData,
                processData: false,
                contentType: false,
                headers: this.ajxHeaders,
                success: function (data) {
                    self.loading = false;
                    if (data.status == "success") {
                        self.$swal({
                            title: "",
                            text: "Backorder Report Updated Successfully.",
                            type: "success",
                            showCancelButton: false,
                            confirmButtonText: "Okay",
                            showCloseButton: false,
                        }).then(result => {
                            self.closeModal();
                            self.loadList();
                        });
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR, false, 'save-backorder-fields');
                }
            });
        },
        clearErrFields() {
            this.backorder_eta_err_msg = '';
            this.backorder_comment_err_msg = '';
            this.backorder_status_err_msg = '';
        },
        validateFields() {
            var success = true;
            this.clearErrFields();

            if (this.backorder_eta == '' || this.backorder_eta == null) {
                this.backorder_eta_err_msg = 'Backorder ETA is required';
                success = false;
            }
            if (this.backorder_comment == '' || this.backorder_comment == null) {
                this.backorder_comment_err_msg = 'Backorder Comment is required';
                success = false;
            }
            if (this.backorder_status == '' || this.backorder_status == null) {
                this.backorder_status_err_msg = 'Backorder Status is required';
                success = false;
            }

            if (success) {
                this.saveBackorderFields();
            } else {
                this.errorValidationFocus();
            }
        },
        loadList() {
            var self = this;
            self.loading = true;
            var fields = {
                page: self.serverParams.page,
                perPage: self.serverParams.perPage,
                filters: self.serverParams.columnFilters,
                sort: self.serverParams.sort,
            };
            $.ajax({
                url: process.env.ROOT_API + "/part-backorder-report",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (data.status == "success") {
                        self.rows = data.content.row;
                        self.totalRecords = data.content.totalRecords;
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR, false, 'gallery-list');
                }
            });
        }
    }
};
</script>
<style scoped>
.loader-vvg {
    z-index: 1063;
}
</style>


// WEBPACK FOOTER //
// src/components/PartBackorderReporting.vue